import React, { useRef } from 'react'
import { Helmet } from 'react-helmet'
import { MdContactSupport, MdPhone } from "react-icons/md";
import utils from '../utils'
import { BsFillSendFill } from "react-icons/bs";
import { FaLocationDot } from 'react-icons/fa6';
import { MdEmail } from "react-icons/md";

function ContactPage() {
    const url = window.location.href
    const emailRef = useRef()
    const subjectRef = useRef()
    const textRef = useRef()

    function mailTo(body, subject) {
        const destinationEmail = "info@regalbikes.com "
        window.location.href = `mailto:${destinationEmail}?subject=${subject}&body=${body}`;
        emailRef.current.value = ''
        subjectRef.current.value = ''
        textRef.current.value = ''
    }

    function submitHandler(e) {
        e.preventDefault()
        const email = emailRef.current.value
        const subject = subjectRef.current.value
        const text = textRef.current.value
        const body = `from: ${email}  content: ${text}`
        mailTo(body, subject)
    }
    return (
        <div>
            <Helmet>
                <title>Contact Us - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    name="description"
                    content="Contact HealthConnect for support, inquiries, or feedback. Reach us via email, phone, WhatsApp, or visit our office in Nairobi, Kenya."
                />
                <meta
                    property="og:title"
                    content="Contact Us - HealthConnect"
                />
                <meta
                    property="og:description"
                    content="Get in touch with our team. We're here to help with any questions about our home healthcare services."
                />
                <meta
                    property="og:type"
                    content="website"
                />
                <meta
                    property="og:url"
                    content={url}
                />
                <meta
                    name="keywords"
                    content="contact HealthConnect, support Kenya, healthcare contact, nurse booking support, Nairobi"
                />
            </Helmet>

            <section className="px-6 md:px-12 py-5 bg-base-100 relative overflow-hidden -mt-4 mb-16">
                <div className="absolute -top-24 -right-24 size-96 bg-primary/10 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-24 -left-24 size-96 bg-blue-400/10 rounded-full blur-3xl"></div>

                <div className="max-w-5xl mx-auto relative z-10">
                    <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider mb-6">
                        <span className="size-2 rounded-full bg-primary mr-2 animate-pulse"></span>
                        Contact Us
                    </span>

                    <h2 className="text-3xl md:text-5xl font-black text-text-main dark:text-white leading-[1.1] tracking-tight mb-8">
                        Get In <span className="text-primary">Touch</span>
                    </h2>

                    <p className="text-lg text-text-secondary dark:text-slate-400 font-light max-w-2xl leading-relaxed">
                        Have questions about our services? Need support with a booking? Our team is here to help you with any inquiries.
                    </p>
                </div>
            </section>


            <main className="flex-1 flex flex-col items-center justify-center px-6">
                <div className="w-full max-w-[1000px] bg-white dark:bg-[#1a2c35] rounded-xl shadow-card overflow-hidden grid md:grid-cols-2 min-h-[600px] border border-border-color dark:border-gray-800 mb-10">
                    <div className="p-8 md:p-12 flex flex-col justify-center order-2 md:order-1 relative">
                        <div className="mb-8">
                            <h1 className="text-3xl font-bold tracking-tight text-text-main dark:text-white mb-2">Get in touch</h1>
                            <p className="text-text-secondary dark:text-gray-400 text-base">Have questions about our nursing services? Send us a message and we'll respond as soon as possible.</p>
                        </div>
                        <form onSubmit={submitHandler}>
                            <div className="form-control mb-3">
                                <label className="label">
                                    <span className="label-text">Email*</span>
                                </label>
                                <input placeholder='email@example.com' type="email" required ref={emailRef} name="email" className="input input-bordered w-full " />
                            </div>
                            <div className="form-control mb-3">
                                <label className="label">
                                    <span className="label-text">Subject</span>
                                </label>
                                <input placeholder='Something you want' type="text" ref={subjectRef} name="email" className="input input-bordered w-full " />
                            </div>
                            <div className="form-control w-full">
                                <label className="label">
                                    <span className="label-text">Text*</span>
                                </label>
                                <textarea placeholder='How can we help you?' ref={textRef} className="textarea textarea-bordered w-full" required cols={3}></textarea>
                            </div>
                            <div className='flex justify-center mt-5'>
                                <button className='btn btn-primary w-full' type='submit'>
                                    Send Message <span className="material-symbols-outlined text-[20px] group-hover:translate-x-1 transition-transform"><BsFillSendFill /></span>
                                </button>
                            </div>
                        </form>
                    </div>

                    <div className="hidden md:flex flex-col relative order-1 md:order-2 bg-slate-50 dark:bg-slate-900 overflow-hidden">
                        <div className="absolute inset-0 z-0">
                            <div className="w-full h-full bg-cover bg-center login-bg" data-alt="Abstract blue and white medical geometric pattern">
                            </div>
                            <div className="absolute inset-0 bg-primary/60 mix-blend-multiply"></div>
                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                        </div>
                        <div className="relative z-10 flex flex-col justify-end h-full p-12 text-white">
                            <div className="size-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center mb-6 border border-white/30">
                                <span className="material-symbols-outlined text-3xl"><MdContactSupport /></span>
                            </div>
                            <h3 className="text-3xl font-bold mb-3 tracking-tight">We're here for you and your health.</h3>
                            <p className="text-white/90 text-lg leading-relaxed max-w-sm">
                                Our team of medical professionals is available 24/7 to ensure you receive the best care in the comfort of your home.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-full mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white dark:bg-[#1a2c35] border border-border-color dark:border-gray-800 p-6 rounded-xl shadow-card flex items-start gap-4 transition-transform hover:-translate-y-1">
                        <div className="size-10 rounded-lg bg-primary/20 flex items-center justify-center text-primary shrink-0">
                            <MdEmail className="text-xl" />
                        </div>
                        <div>
                            <h4 className="font-bold text-text-main dark:text-white">Email Support</h4>
                            <p className="text-text-secondary dark:text-gray-400 text-sm mt-1">support@nursesbk.com</p>
                        </div>
                    </div>
                    <div className="bg-white dark:bg-[#1a2c35] border border-border-color dark:border-gray-800 p-6 rounded-xl shadow-card flex items-start gap-4 transition-transform hover:-translate-y-1">
                        <div className="size-10 rounded-lg bg-primary/20 flex items-center justify-center text-primary shrink-0">
                            <FaLocationDot className="text-xl" />
                        </div>
                        <div>
                            <h4 className="font-bold text-text-main dark:text-white">Our Location</h4>
                            <p className="text-text-secondary dark:text-gray-400 text-sm mt-1">123 Avenue, Nairobi, Kenya.</p>
                        </div>
                    </div>
                    <div className="bg-white dark:bg-[#1a2c35] border border-border-color dark:border-gray-800 p-6 rounded-xl shadow-card flex items-start gap-4 transition-transform hover:-translate-y-1">
                        <div className="size-10 rounded-lg bg-primary/20 flex items-center justify-center text-primary shrink-0">
                            <MdPhone className="text-xl" />
                        </div>
                        <div>
                            <h4 className="font-bold text-text-main dark:text-white">Call Us</h4>
                            <p className="text-text-secondary dark:text-gray-400 text-sm mt-1">+254 700 000 000</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ContactPage